<template>
  <div>
    <g-breadcrumb :paginas="paginaStatus.caminhoMigalha" />
    <g-pesquisa
      ref="refPesquisa"
      :filtroAdicional="getFiltroPesquisa"
      :limparFiltroLocal="limparFiltro"
      :colunasPropriedade=colunas
      :apiPesquisa="apiAssunto"
      :operacoes="operacoes"
      :exibirColunaOperacoes="exibirColunaOperacoes"
      :elementosPorPagina="elementosPorPagina"
      :novo="cadastrarItem"
      :imprimir="imprimir"
      :showTermoPesquisa="false"
      :showBuscaAvancadaAberta="true"
      :carregamentoInicial="false"
      :showBotaoNovo="permissaoPerfil.incluir"
    >

      <div class="row">
        <div class="col-sm-12 col-xs-12">
          <g-input
            id="refDescricao"
            name="refDescricao"
            ref="refDescricao"
            tipo="text"
            etiqueta="Descrição"
            :foco="false"
            :tamanho="100"
            :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
            v-model="assunto.desAssunto"
          >
          </g-input>
        </div>
      </div>
      <br />
    </g-pesquisa>
  </div>
</template>

<script>

import utilHttp from 'components/util/utilHttp'
import msg from 'components/util/msg'
import GBreadcrumb from 'components/util/gBreadcrumb'
import GInput from 'components/util/gInput'
import GSelect from 'components/util/gSelect'
import GPesquisa from 'components/util/gPesquisa'
import GAutocomplete from 'components/util/gAutocomplete'
import constante from 'components/util/constante'
import api from 'components/util/api'

import util from 'components/util/util'
// import utilHttp from 'components/util/utilHttp'
export default {

  data () {
    return {
      pagina: 1,
      elementosPorPagina: 10,
      apiAssunto: api.ASSUNTO,
      exibirColunaOperacoes: true,
      permissaoPerfil: '',
      assunto: {

      },
      paginaStatus: {
        assunto: {},
        desabilitarEdicao: false,
        caminhoMigalha: [
          {
            icone: '',
            descricao: '',
            rotaNome: ''
          }
        ]
      },
      colunas: [
        {
          conteudoTipo: '',
          largura: '60%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Descrição',
          conteudoClasse: 'text-left',
          propriedade: 'desAssunto'
        },
        {
          conteudoTipo: 'badge',
          propriedade: 'indVisivelPortal',
          cabecalhoEtiqueta: 'Visível no Portal',
          cabecalhoClasse: 'text-center',
          conteudoClasse: 'text-center',
          largura: '10%',
          arrayOpcoes: constante.ATIVO_ENUM
        },
        {
          conteudoTipo: 'badge',
          propriedade: 'indAtivo',
          cabecalhoEtiqueta: 'Ativo',
          cabecalhoClasse: 'text-center',
          conteudoClasse: 'text-center',
          largura: '10%',
          arrayOpcoes: constante.ATIVO_ENUM
        }
      ],
      operacoes: [
        {
          cor: 'blue',
          icone: 'fas fa-search',
          tooltip: 'Visualizar Assunto',
          clique: this.visualizarItem,
          permissao: (row) => true,
          visivel: (row) => true
        },
        {
          cor: 'orange',
          icone: 'fas fa-edit',
          tooltip: 'Editar Assunto',
          clique: this.editarItem,
          permissao: (row) => this.permissaoPerfil.alterar,
          visivel: (row) => this.permissaoPerfil.alterar
        },
        {
          cor: 'red',
          icone: 'fas fa-trash',
          tooltip: 'Excluir Assunto',
          clique: this.excluirItem,
          permissao: (row) => this.permissaoPerfil.excluir,
          visivel: (row) => this.permissaoPerfil.excluir
        }
      ]

    }
  },
  methods: {
    limparFiltro () {
      this.assunto = {}
    },
    imprimir () {
      util.exibirToastInfo(msg.m(12))
    },
    excluirItem (item) {
      util.exibirConfirmacaoExclusao('EXCLUIR', msg.m(5), () => {
        var filtro = '/'.concat(item.codAssunto)

        utilHttp.httpDeletePorID(api.ASSUNTO.concat(filtro), resposta => {
          util.exibirToastSucesso(msg.m(4))
          this.pesquisarPrimeiraPagina()
        })
      })
    },
    visualizarItem (item) {
      this.paginaStatus.assunto = item
      this.paginaStatus.desabilitarEdicao = true
      this.paginaStatus.operacao = {
        descricao: 'Visualizar Assunto',
        icone: 'fa fa-search'
      }
      this.$router.push({
        name: 'assunto',
        params: {
          paginaStatus: this.paginaStatus
        }
      })
    },
    editarItem (item) {
      this.paginaStatus.assunto = item
      this.paginaStatus.desabilitarEdicao = false
      this.paginaStatus.operacao = {
        descricao: 'Editar Assunto Geral',
        icone: 'fa fa-edit'
      }
      this.$router.push({
        name: 'assunto',
        params: {
          paginaStatus: this.paginaStatus
        }
      })
    },
    getFiltroPesquisa () {
      var filtro = ''
      var self = this
      if (self.assunto.desAssunto) filtro = filtro.concat('&desAssunto=').concat(self.assunto.desAssunto)
      return filtro
    },
    cadastrarItem () {
      this.paginaStatus.operacao = {
        descricao: 'Novo',
        icone: 'fa fa-plus'
      }
      this.$router.push({
        name: 'assunto',
        params: {
          paginaStatus: this.paginaStatus
        }
      })
    },
    pesquisarPrimeiraPagina () {
      this.$refs['refPesquisa'].pesquisar()
    }
  },
  watch: {
    paginaStatus: {
      handler (valor) {
        if (valor) {
          util.adicionarNoStorage(this.chaveLocalStorage, valor)
        } else util.removerDoStorage(this.chaveLocalStorage)
      },
      deep: true
    }
  },
  mounted () {
    this.paginaStatus.caminhoMigalha = [
      {
        icone: 'fas fa-folder-open',
        descricao: 'Assunto',
        rotaNome: 'assuntoPesquisa'
      }
    ]
    // this.pesquisarPrimeiraPagina()

    this.permissaoPerfil = util.montarPermissoes(this.$router.history.current.path)
  },
  components: { GBreadcrumb, GInput, GSelect, GPesquisa, GAutocomplete }
}
</script>
